/**
 * Centralized configuration for feature access control
 * Contains user IDs and group IDs for feature-gating
 */

// User IDs with access to Dify Chatbot
export const CHATBOT_ALLOWED_USERS = [127, 62, 56];
export const CHATBOT_ALLOWED_GROUPS = [-4]; // boss group

// User IDs with access to FNN feature
export const FNN_ALLOWED_USERS = [56, 127, 230, 245, 62];

// Admin user IDs for special permissions (spravochnik, etc.)
export const ADMIN_USERS = [1, 56, 62];

/**
 * Check if user has access to chatbot feature
 * @param {Object} user - User object with id and group_id
 * @returns {boolean}
 */
export const hasChatbotAccess = (user) => {
  if (!user) return false;
  return (
    CHATBOT_ALLOWED_USERS.includes(user.id) ||
    CHATBOT_ALLOWED_GROUPS.includes(user.group_id)
  );
};

/**
 * Check if user has access to FNN feature
 * @param {Object} user - User object with id
 * @returns {boolean}
 */
export const hasFnnAccess = (user) => {
  if (!user) return false;
  return FNN_ALLOWED_USERS.includes(user.id);
};

/**
 * Check if user has admin permissions
 * @param {Object} user - User object with id
 * @returns {boolean}
 */
export const isAdminUser = (user) => {
  if (!user) return false;
  return ADMIN_USERS.includes(user.id);
};
